module.exports = __webpack_public_path__ + "static/media/animaflix.93f90a53.png";